import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';

/**
 * Join Meeting Screen Component
 * Displays before user joins the video call
 */
function JoinMeetingScreen({ 
  participantName,
  onJoinMeeting,
  isLoading = false,
  hasError = false 
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
        px: 2,
      }}
    >
      <Typography variant="h5" sx={{ mb: 2 }}>
        Ready to join the meeting?
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Meeting with: {participantName}
      </Typography>
      
      <Button
        variant="contained"
        size="large"
        onClick={onJoinMeeting}
        disabled={isLoading || hasError}
        sx={{
          fontWeight: 600,
          px: 4,
          py: 1.5,
          borderRadius: 2,
          backgroundColor: (isLoading || hasError) ? 'grey.400' : 'primary.main',
          '&:hover': {
            backgroundColor: (isLoading || hasError) ? 'grey.400' : 'primary.dark',
          },
        }}
      >
        {isLoading ? 'Loading...' :
          hasError ? 'Connection Error' :
            'Join Meeting'}
      </Button>
      
      {isLoading && (
        <CircularProgress size={24} sx={{ mt: 2 }} />
      )}
      
      {hasError && (
        <Typography variant="body2" color="error" sx={{ mt: 1 }}>
          Unable to establish connection. Please try again.
        </Typography>
      )}
    </Box>
  );
}

export default JoinMeetingScreen;
